document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('brand-search-input');
  
  if (!searchInput) return;
  
  let debounceTimer;
  
  searchInput.addEventListener('input', function(e) {
    clearTimeout(debounceTimer);
    
    debounceTimer = setTimeout(() => {
      const searchValue = e.target.value.trim();
      
      if (searchValue.length === 0) return;
      
      // 移除 "For " 前缀（如果存在）
      const cleanValue = searchValue.replace(/^for\s+/i, '');
      
      // 获取首字母并转换为大写
      const firstLetter = cleanValue.charAt(0).toUpperCase();
      
      // 检查是否为字母
      if (!/[A-Z]/i.test(firstLetter)) return;
      
      // 使用大写字母构建 ID
      const targetId = 'brand-letter-' + firstLetter;
      
      const targetSection = document.getElementById(targetId);
      
      if (targetSection) {
        // 平滑滚动到目标位置
        targetSection.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start',
          inline: 'nearest'
        });
        
        // 添加高亮效果
        targetSection.classList.add('brand-highlight');
        setTimeout(() => {
          targetSection.classList.remove('brand-highlight');
        }, 2000);
      }
    }, 300);
  });
});
